/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * CEV Job Status.
 */
export enum CevJobStatus {
    MIGRATED = 'MIGRATED',
    NOT_MIGRATED = 'NOT_MIGRATED',
}
